package one.healthium.tutorial.navigation

import com.arkivanov.decompose.ComponentContext
import com.arkivanov.decompose.router.pages.ChildPages
import com.arkivanov.decompose.router.pages.Pages
import com.arkivanov.decompose.router.pages.PagesNavigation
import com.arkivanov.decompose.router.pages.childPages
import com.arkivanov.decompose.router.pages.selectNext
import com.arkivanov.decompose.value.Value
import com.arkivanov.essenty.lifecycle.coroutines.coroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable
import one.healthium.tutorial.domain.TutorialInteractor
import one.healthium.tutorial.domain.TutorialModel
import one.healthium.tutorial.domain.TutorialScreenConfig
import one.healthium.tutorial.navigation.screen.DefaultTutorialScreenComponent
import one.healthium.tutorial.navigation.screen.TutorialScreenComponent
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

class DefaultTutorialComponent(
    componentContext: ComponentContext,
    override val model: TutorialModel.IntroTutorial,
    private val onFinished: () -> Unit,
) : TutorialComponent, ComponentContext by componentContext, KoinComponent {

    private val navigation = PagesNavigation<Config>()

    private val tutorialInteractor by inject<TutorialInteractor>()

    private val scope = coroutineScope(Dispatchers.Main.immediate + SupervisorJob())

    override val pages: Value<ChildPages<*, TutorialScreenComponent>> =
        childPages(
            source = navigation,
            serializer = Config.serializer(),
            initialPages = {
                Pages(
                    items = model.screens.map { Config(screenConfig = it) },
                    selectedIndex = 0,
                )
            },
        ) { config, childComponentContext ->
            DefaultTutorialScreenComponent(
                componentContext = childComponentContext,
                screenConfig = config.screenConfig,
                onNextClicked = ::onNextClicked,
            )
        }

    private fun onNextClicked() {
        if (pages.value.selectedIndex == model.screens.lastIndex) {
            scope.launch { tutorialInteractor.setIntroTutorialShown() }
            onFinished()
        } else {
            navigation.selectNext()
        }
    }

    @Serializable
    private data class Config(
        val screenConfig: TutorialScreenConfig,
    )
}
